module.exports = __webpack_public_path__ + "static/09-3ee86c3db0aa65ac61beec2f2b0952b1.jpg";